export const CONFIGURATION_PREPEND = "/configuration";
export const STAFF_PREPEND = "/staff";
export const STUDENT_PREPEND = "/student";
export const FACULTY_PREPEND = "/faculty";
export const FRESHMAN_PREPEND = "/freshman";
export const AI_CONFIGURATION_PREPEND ="/ai"

export const FRESHMAN_PROCESS_APPROVAL_PREPEND = "/freshman-process-approval";



export const ROUTER_URL = {
  ROOT: "/",
  MASTER_UNITS: "/master-units",
  STUDENT_DASHBOAD: "/student-dashboad",
  STUDENT_RESOURCES: "/student-resources",
  STUDENT_NOTIFICATION: "/student-notification",
  SUPER_ADMIN_DASHBOAD: "/super-admin-dashboad",
  SUPER_ADMIN_FEEDBACK: "/super-admin-feedback",
  COLLEGE_ADMIN_DASHBOAD: "/college-admin-dashboad",
  DEPARTMENT_ADMIN_DASHBOARD: "/department-admin-dashboad",
  FACULTY_DASHBOARD: "/faculty-dashboad",
  FACULTY_SENDTOMAIL: "/faculty-send-to-mail",
  FACULTY_RESOURCES: "/faculty-resources",
  FACULTY_CONNECT: "/faculty-connect",
  FACULTY_NOTIFICATION: "/faculty-notification",
  FACULTY_FEEDBACK: "/faculty-feedback",
  FACULTY_REPORTS: "/faculty-reports",
  FACULTY_DAILY_REPORTS: "/faculty-daily-reports",
  FACULTY_MONTHLY_REPORTS: "/faculty-monthly-reports",
  FACULTY_YEARLY_REPORTS: "/faculty-yearly-reports",
  FACULTY_ALL_QUICK_LINKS: "/faculty-all-quick-links",
  FACULTY_ALL_TASKS: "/faculty-all-tasks",
  STUDENT_SENDTOMAIL: "/student-send-to-mail",
  STUDENT_ACADEMIC_PROFILE: "/academic-profile",
  STUDENT_CAREER_PATH: "/career-path",
  STUDENT_ACCOUNTS: "/student-accounts",
  STUDENT_COURSES: "/student-courses",
  STUDENT_GRADES: "/student-grades",
  STUDENT_COURCE_DETAIL: "/student-cource-detail",
  STUDENT_TRANSACTIONS: "/studentTransactions",
  STUDENT_FEEDBACK: "/student-feedback",
  LOGIN: "/login",
  SETTINGS: "/settings",
  INSTRUCTIONS: "/instructions",
  ADMIN_SETTINGS: "/admin-settings",
  RESOURCES: "/resources",
  FEEDBACK: "/feedback",
  ALL_WIDGETS: "/all-widgets",
  STAFF_DASHBOARD: "/staff-dashboad",
  STAFF_NOTIFICATIONS: "/staff-notifications",
  STAFF_TRAINING: "/staff-training",
  STAFF_REPORTS: "/staff-reports",
  STAFF_COMMUNICATION: "/staff-communication",
  STAFF_RESOURCES: "/staff-resources",
  STAFF_CONNECT: "/staff-connect",
  STAFF_SEND_MAIL: "/staff_send_mail",
  STAFF_FEEDBACK: "/staff_feedback",
  STAFF_NOTIFICATION: "/staff-notification",
  STAFF_ALL_HR_AND_BENIFITS: "/staff-all-hr-and-benifits",
  STAFF_ALL_FINANCE_RESOURCES: "/staff-all-finance-resources",
  STAFF_ALL_TECHNOLOGY_RESOURCES: "/staff-all-technology-resources",
  STAFF_ALL_CAMPUS_SAFETY: "/staff-all-campus-safety",
  STAFF_ALL_CAMPUS_EVENTS: "/staff-all-campus-events",
  STAFF_ALL_EMPLOYEE_TRAINING: "/staff-all-training-block",
  STAFF_ALL_DAILY_REPORTS: "/staff-all-daily-reports",
  STAFF_ALL_WEEKLY_REPORTS: "/staff-all-weekly-reports",
  STAFF_ALL_ANNUALLY_REPORTS: "/staff-all-annually-reports",
  NOTIFICATION: "/notification",
  FRESHMAN_PROCESS: "/freshman-process",
  FRESHMAN_PROCESS_APPROVAL: FRESHMAN_PROCESS_APPROVAL_PREPEND,
  // SUPER_ADMIN_FEEDBACK : "/admin-feedback",
  BETA: "/beta",


  //widgets
  EDIT_WIDGET: "edit-widget",
  STAFF_SENDTOMAIL: "/staff-send-to-mail",
  STUDENT_SEND_MAIL: '/student-send-to-mail',

  COLLEGE_INDEX: "/colleges",
  COLLEGE_DETAILS: "/college-details",
  DEPARTMENT_INDEX: "/departments",
  DEPARTMENT_DETAILS: "/department-details",


  // View All
  STUDENT_PLAN_NEXT_TERM: "/student-nexterm-viewall",
  QUICK_LINKS_VIEW_ALL: "/student-quicklinks-viewall",
  STUDENT_RESOURCE_VIEW_ALL: "/student-resource-viewall",

  AI_CONFIGURATION: "ai-configuration"
};

export const FRESHMAN_ROUTER_URL = {
  FRESHMAN_MAINSTEP_INDEX: FRESHMAN_PREPEND + "/mainstep-index",
  FRESHMAN_SUBSTEP_INDEX: FRESHMAN_PREPEND + "/substep-index",
  FRESHMAN_CONFIGURATION_INDEX: FRESHMAN_PREPEND + "/freshman-configuration",
}

//master
export const CONFIGURATION_ROUTER_URL = {
  BUTTON_INDEX: CONFIGURATION_PREPEND + "/buttons",
  WIDGET_INDEX: CONFIGURATION_PREPEND + "/widgets",
  APP_INDEX: CONFIGURATION_PREPEND + "/apps",
  STUDENT_RESOURCE_INDEX: CONFIGURATION_PREPEND + "/student-resource",
  STUDENT_HELP_INDEX: CONFIGURATION_PREPEND + "/student-help",
  NOTIFICATION_INDEX: CONFIGURATION_PREPEND + "/notification",
  TECHNOLOGY_RESOURCE_INDEX: CONFIGURATION_PREPEND + "/technology-resource",
  MEDIA_CONTENT_INDEX: CONFIGURATION_PREPEND + "/media-content",
  TRAINING_INDEX: CONFIGURATION_PREPEND + "/training",
  REPORT_INDEX: CONFIGURATION_PREPEND + "/reports",
  DEPARTMENT_RESOURCE_INDEX: CONFIGURATION_PREPEND + "/department-resources",
  TRAINING_HELP_INDEX: CONFIGURATION_PREPEND + "/training-help",
  EMAIL_CONFIGURATION_INDEX: CONFIGURATION_PREPEND + "/email-configuration",
  DESCRIPTION_INDEX: CONFIGURATION_PREPEND + "/description",
}

// staff
export const STAFF_ROUTER_URL = {
  BUTTON_PRIORITY: STAFF_PREPEND + "/buttons",
  WIDGET_PRIORITY: STAFF_PREPEND + "/widgets",
  APPS_PRIORITY: STAFF_PREPEND + "/apps",
  NOTIFICATION_PRIORITY: STAFF_PREPEND + "/notifications",
  TECHNOLOGY_RESOURCE_PRIORITY: STAFF_PREPEND + "/technology-resources",
  MEDIA_CONTENT_PRIORITY: STAFF_PREPEND + "/media-contents",
  SNAPSHOT_PRIORITY: STAFF_PREPEND + "/snapshots",
  TRAINING_PRIORITY: STAFF_PREPEND + "/training",
  REPORT_PRIORITY: STAFF_PREPEND + "/reports",
  DEPARTMENT_RESOURCE_PRIORITY: STAFF_PREPEND + "/department-resources",
  TRAINING_HELP_PRIORITY: STAFF_PREPEND + "/training-help",
}

// student
export const STUDENT_ROUTER_URL = {
  BUTTON_PRIORITY: STUDENT_PREPEND + "/buttons",
  WIDGET_PRIORITY: STUDENT_PREPEND + "/widgets",
  APPS_PRIORITY: STUDENT_PREPEND + "/apps",
  STUDENT_RESOURCE_PRIORITY: STUDENT_PREPEND + "/student-resources",
  STUDENT_HELP_PRIORITY: STUDENT_PREPEND + "/student-help",
  NOTIFICATION_PRIORITY: STUDENT_PREPEND + "/notifications",
  SNAPSHOT_PRIORITY: STUDENT_PREPEND + "/snapshots"
}

// faculty
export const FACULTY_ROUTER_URL = {
  BUTTON_PRIORITY: FACULTY_PREPEND + "/buttons",
  WIDGET_PRIORITY: FACULTY_PREPEND + "/widgets",
  APPS_PRIORITY: FACULTY_PREPEND + "/apps",
  NOTIFICATION_PRIORITY: FACULTY_PREPEND + "/notifications",
  SNAPSHOT_PRIORITY: FACULTY_PREPEND + "/snapshots",
  REPORT_PRIORITY: FACULTY_PREPEND + "/reports"
}



